<div *ngIf="token$ | async" class="contact-us-content">
  <h3 class="contact-info-heading">Contact Information</h3>
  <hr class="contact-info-divider">
  <div class="row contact-info-row">
    <div class="columns small-12 medium-8 contact-description">
      <p>
        Contact the local Client Service team via phone or email for any assistance related to the Investor Portal or
        your
        investments in the Mercer Funds.
      </p>
    </div>
    <div class="columns small-12 medium-4 contact-details">
      <div class="contact-item">
        <atlas-icon [icon]="'icon-phone-24'" [size]="'medium'" [alt]="'phone'"></atlas-icon>
        <span class="contact-value">{{ (staticData$ | async).phone }}</span>
      </div>
      <div class="contact-item">
        <atlas-icon [icon]="'icon-mail-24'" [size]="'medium'" [alt]="'email'"></atlas-icon>
        <span class="contact-value">{{ (staticData$ | async).email }}</span>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!(token$ | async)">

  <div *ngIf="(staticDataLogin$ | async)">
    <div class="mos-c-accordion--raised">
      <atlas-accordion>
        <atlas-accordion-item #accordionRef *ngFor="let staticData of staticDataLogin$ | async; let i=index"
          [expanded]="i===expandedIndex" (onExpand)="onExpandItem(i)">

          <atlas-accordion-heading>
            <div class="row">
              <div class="columns shrink mos-o-body-2 country-name">{{staticData.countryFullName}}</div>
            </div>
          </atlas-accordion-heading>
          <atlas-accordion-content>
            <div class="row">
              <div class="columns small-12 medium-12">
                <p>
                  Contact the local Client Service team via phone or email for any assistance
                  related to the Investor Portal or your investments in the Mercer Funds.
                </p>
              </div>
              <div class="columns small-12 medium-12 login-contact">
                <div class="contact-item">
                  <atlas-icon [icon]="'icon-phone-24'" class="icon-landing-page" [size]="'large'" color="primary"
                    [alt]="'phone'"></atlas-icon>
                  &nbsp;
                  <span class="contact-value">{{ staticData.data.phone }}</span>
                </div>
                <div class="contact-item">
                  <atlas-icon [icon]="'icon-mail-24'" class="icon-landing-page" size="large" color="primary"
                    [alt]="'email'"></atlas-icon>
                  &nbsp;
                  <span class="contact-value">{{ staticData.data.email }}</span>
                </div>
              </div>
            </div>
          </atlas-accordion-content>
          <atlas-accordion-expand>
            <div class="accordian-expand-icon">
              <atlas-icon-button collection="arrows-solid"
                [icon]="accordionRef.expanded ? 'chevron-up' : 'chevron-down'"></atlas-icon-button>
            </div>
          </atlas-accordion-expand>
        </atlas-accordion-item>
      </atlas-accordion>
    </div>
  </div>
  <div class='footer'></div>
</div>